<template>
  <div id="contenedor-main-listado-contratos-relacionados">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :listadoContratosRelacionados="listadoContratosRelacionados"></desktop>
    </template>
    <template v-else>
      <!-- <mobile :listadoContratosRelacionados="listadoContratosRelacionados"></mobile> -->
      <desktop :listadoContratosRelacionados="listadoContratosRelacionados"></desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoContratosRelacionados',
  props: {
    listadoContratosRelacionados: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
